import React, { useEffect } from "react";
import { CheckOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Avatar, Button, List } from "antd";

export const SelectedOrganizations = ({
  selectedOrgs,
  onRemoveContr,
  onShowContributeModal,
}) => {

  const onEdit = (record) => {
    onShowContributeModal(record);
  };

  const onRemove = (record) => {
    onRemoveContr(record);
  };
  
    return (
    <div className="added-orgs">
      <div>
        <h2>Partner(s) that will be added to the project</h2>
      </div>
      <List
        itemLayout="horizontal"
        dataSource={selectedOrgs}
        renderItem={(item, index) => (
          <List.Item
            actions={[
              <Button
                onClick={() => onEdit(item)}
                style={{ backgroundColor: "#0968AF", color: "#fff", borderRadius: "100px" }}
              >
                <EditOutlined />
              </Button>,
              // <Button
              //   onClick={() => onRemove(item.id)}
              //   style={{ backgroundColor: "#BB0303", color: "#FFF", borderRadius: "100px" }}
              // >
              //   <DeleteOutlined />
              // </Button>,
            ]}
          >
            <List.Item.Meta
              key={item.id}
              avatar={
                <Avatar style={{ backgroundColor: "#6DBB5D", marginLeft: "15px" }} icon={<CheckOutlined style={{ color: "#FFF" }} />} />
              }
              title={`${item.name} - ${item.address}, ${item.type}`}
            />
          </List.Item>
        )}
      />
    </div>
  );
};
